import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { openWhatsApp } from '../utils/whatsapp';

export const MobileStickyCTA = () => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 grid w-full min-w-0 max-w-full grid-cols-2 gap-2 overflow-x-hidden border-t border-slate-200 bg-white px-2 py-2 shadow-[0_-4px_12px_-2px_rgba(0,0,0,0.08)] lg:hidden"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={`tel:${contactInfo.phone}`}
        className="flex min-w-0 flex-col items-center justify-center overflow-hidden py-2 rounded-lg text-blue-700 bg-blue-50 active:bg-blue-100"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-5 h-5" />
        <span className="max-w-full truncate text-xs font-semibold mt-0.5">Call</span>
      </a>
      <button
        onClick={() => openWhatsApp()}
        className="flex min-w-0 flex-col items-center justify-center overflow-hidden py-2 rounded-lg text-white bg-emerald-600 active:bg-emerald-700"
        data-testid="sticky-whatsapp-btn"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="max-w-full truncate text-xs font-semibold mt-0.5">WhatsApp</span>
      </button>
    </div>
  );
};
